import axios from 'axios';
import { getCookie } from '@/utils/cookies';

const baseDomain = process.env.VUE_APP_GATEWAY;
const basePort = process.env.VUE_APP_GATEWAY_PORT;

const baseURL = process.env.NODE_ENV === 'production' ? `${window.location.origin}/help-api/` : `${baseDomain}:${basePort}`;

const api = axios.create({
  baseURL,
});

api.interceptors.response.use((response) => {
  let answer = response.data || {};
  switch (response.config.url) {
    case '/language': {
      answer = response.data.languages;
      break;
    }
    case '/menu': {
      answer = response.data.leftMenuItems;
      break;
    }
    case '/currency': {
      answer = response.data.currencyList;
      break;
    }
    case '/payment-provider': {
      answer = response.data;
      break;
    }
    case '/config': {
      answer = response.data;
      break;
    }
    case '/country': {
      answer = response.data.countryList;
      break;
    }
    default: {
      break;
    }
  }
  return answer;
});

export default api;
